<template>
  <div class="tw:rounded-xl tw:bg-white tw:overflow-hidden" data-testid="pro-to-plus-reactivation-section">
    <!-- Brand header row -->
    <div class="tw:pt-5 tw:pb-0">
      <img :src="businessStudioPlusLogo" class="tw:h-4" alt="trivago Business Studio+" />
    </div>

    <!-- Title -->
    <h2 class="tw:text-xl tw:font-bold tw:text-gray-900 tw:pt-4">
      {{ $t('pro_plus_header') }}
    </h2>

    <!-- Shared content: features + pricing band -->
    <ProToPlusReactivationContent
      :isPriceLoading="isPriceLoading"
      :plusMonthlyPrice="plusMonthlyPrice"
      :annualPrice="annualPrice"
      :proPrice="proPrice"
      :isPricingComparison="isPricingComparison"
      :monthlySavings="monthlySavings"
    />

    <!-- CTAs -->
    <div class="tw:flex tw:justify-end tw:flex-wrap tw:gap-3 tw:pb-6">
      <GhostButton
        class="tw:flex tw:items-center tw:gap-x-2"
        @click="openVideo"
        data-testid="pro-to-plus-inline-see-how-it-works"
      >
        <PlayIcon class="tw:fill-gray-800" />
        {{ $t('promo_video_cta') }}
      </GhostButton>
      <MainButton @click="$emit('reactivate')" data-testid="pro-to-plus-inline-reactivate">
        {{ $t('reactivate_plus_subscription_cta') }}
      </MainButton>
    </div>

    <!-- Video modal -->
    <VideoModal :isOpen="isVideoOpen" @closeModal="isVideoOpen = false" title="plus_promo_video_header" />
  </div>
</template>

<script setup>
import { ref } from 'vue'

import GhostButton from '@/components/base/buttons/GhostButton.vue'
import MainButton from '@/components/base/buttons/MainButton.vue'
import PlayIcon from '@/components/icons/PlayIcon.svg?component'
import VideoModal from '@/components/homePage/studioPlus/VideoModal.vue'
import ProToPlusReactivationContent from '@/components/billing/premiumProducts/reactivation/ProToPlusReactivationContent.vue'

defineProps({
  isPriceLoading: {
    type: Boolean,
    default: false,
  },
  plusMonthlyPrice: {
    type: Number,
    default: 0,
  },
  annualPrice: {
    type: Number,
    default: 0,
  },
  proPrice: {
    type: Number,
    default: 0,
  },
  isPricingComparison: {
    type: Boolean,
    default: false,
  },
  monthlySavings: {
    type: Number,
    default: 0,
  },
})

const emit = defineEmits(['reactivate', 'videoOpened'])

const businessStudioPlusLogo = new URL('/src/assets/img/landing/landing_studio_plus.svg', import.meta.url)

const isVideoOpen = ref(false)

const openVideo = () => {
  isVideoOpen.value = true
  emit('videoOpened')
}
</script>
